import { render, staticRenderFns } from "./readerTime.vue?vue&type=template&id=786b1c12&scoped=true&"
import script from "./readerTime.vue?vue&type=script&lang=js&"
export * from "./readerTime.vue?vue&type=script&lang=js&"
import style0 from "./readerTime.vue?vue&type=style&index=0&id=786b1c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786b1c12",
  null
  
)

export default component.exports